import { SET_CONFIGURATION } from './types';

interface IConfiguration {
  name: null | string;
  createdUser: string;
  project: {
    id: string;
    name: string;
    organizationUnitId: number;
  };
}

const initialState: null | IConfiguration = null;

export default (
  state = initialState,
  action: {
    configuration: null | IConfiguration;
    type: string;
  }
): null | IConfiguration => {
  if (action.type === SET_CONFIGURATION) {
    return action.configuration;
  }

  return state;
};
